export default "__VITE_ASSET__C1DLX5IE__"